import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: SENTRY_DSN,
  release: COMMIT_HASH,
  denyUrls: [
    /extensions\//i,
    /extension:/i,
    /^chrome:\/\//i,
    /ajs-assets\.ftstatic\.com/i,
    /amazon-adsystem/i,
    /cdn\.js7k\.com/i,
    /connect\.facebook\.net/i,
    /geoedge\.be/i,
    /doubleclick\.net/i,
    /instagram\.com/i,
    /maps\.googleapis\.com/i,
    /pinterest\.com/i,
    /rubiconproject\.com/i,
    /s\.yimg\.jp/i,
    /s-onetag\.com/i,
    /twitter\.com/i,
  ],
  ignoreErrors: [
    /can't execute code from a freed script/i,
    /can't find variable: (yahoo|gmo)/i,
    /securityerror: blocked a frame with origin/i,
    /serviceworker/i,
    "Function expected",
  ],
  autoSessionTracking: false,
  enableTracing: false,
});
